import apiClient from '../../shared/services/apiClient';

// CDN 端点 DNS 同步运维接口（预览 / 立即同步 / 日志）。
// 后端返回顶层字段（logs / status / add / remove ...），不包在 data 里。
const wrap = async (fn) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message, ...(error.response?.data || {}) };
  }
};

const cdnDnsOpsService = {
  getStatus: (groupId = null) =>
    wrap(() => apiClient.get('/api/admin/cdn/dns-sync/status', { params: groupId ? { group_id: groupId } : {} })),

  // 只读预览：与调度器同一 planGroup，不写 DNS
  previewGroup: (groupId) => wrap(() => apiClient.get(`/api/admin/cdn/dns-sync/preview/${groupId}`)),

  // 立即对某组跑一轮（模式取服务端 CDN_DNS_SYNC_MODE）
  syncGroup: (groupId) => wrap(() => apiClient.post(`/api/admin/cdn/dns-sync/group/${groupId}`)),

  syncAll: () => wrap(() => apiClient.post('/api/admin/cdn/dns-sync/all')),

  cleanup: () => wrap(() => apiClient.post('/api/admin/cdn/dns-sync/cleanup')),
};

// 把 syncGroup 单组结果翻成一条提示：{ type: 'success'|'warning'|'info'|'error', text }
export const describeSyncResult = (r) => {
  if (!r || r.success === false) {
    return { type: 'error', text: `同步失败：${r?.error || '未知错误'}` };
  }
  if (r.skipped) {
    return { type: 'info', text: `已跳过：${r.message || '分组未启用'}` };
  }
  const added = Number(r.records_added) || 0;
  const deleted = Number(r.records_deleted) || 0;
  const updated = Number(r.records_updated) || 0;
  const plannedAdd = r.diff?.add?.length || 0;
  const plannedDel = r.diff?.remove?.length || 0;
  switch (r.status) {
    case 'guarded': {
      const notes = (r.diff?.notes || []).join('；');
      return { type: 'warning', text: `护栏拦截，未改动${r.diff?.frozen ? '（健康数据陈旧，冻结）' : ''}${notes ? '：' + notes : ''}` };
    }
    case 'dryrun':
      return { type: 'info', text: `演练模式，未写入：计划 +${plannedAdd} / -${plannedDel}` };
    case 'skipped':
      return { type: 'warning', text: '变更未落库（并发保护跳过），下一轮会重试' };
    default:
      if (!added && !deleted && !updated) {
        return { type: 'success', text: '已是最新，无变更' };
      }
      return { type: 'success', text: `已应用：+${added} / -${deleted} / 更新 ${updated}` };
  }
};

export default cdnDnsOpsService;
